import React from "react";
import { useParams } from "react-router";
import { useTranslation } from "react-i18next";
import FisheryDepartmentNotes from "./FisheryDepartmentNotes";
import { getFisheryDepartmentLandingNotesApi } from "api/registration";

const FisheryDepartmentLandingNote: React.FC = () => {
	const { id } = useParams();
	const { t } = useTranslation();

	return (
		<FisheryDepartmentNotes
			id={Number(id)}
			title={t("FisheryDepartmentLandingNotes")}
			apiMethod={getFisheryDepartmentLandingNotesApi}
		/>
	);
};

export default FisheryDepartmentLandingNote;
